module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_05.0c569e95.png";